export default "__VITE_ASSET__Bh6iJgRP__"